import { useMediaQuery } from '@mui/material';
import imgContatos from '../../../../assets/images/banner_faleConosco.png';
import DefaultText from '../../../../components/typography/default-text';
import styles from './styles.module.css';

const Contatos: React.FC = () => {

  const isMobile = useMediaQuery('(max-width: 899px)');

  return (
    <>
      <div className={styles["sub-page-content"]}>
        <div className={styles["contatos-banner-container"]}>
          <div className={styles["contatos-banner-text"]}>
            <div>
              <DefaultText size="medium" sx={{ fontFamily: 'Montserrat-Regular' }}>Contatos</DefaultText>
              <DefaultText size="medium" sx={{ fontFamily: 'Montserrat-Bold' }}><i>TELEMONT</i></DefaultText>
            </div>
            <div className={styles['contact-holder']}>
              <DefaultText size={isMobile ? "xs" : "small"} sx={{ fontFamily: 'Montserrat-Bold', lineHeight: '20px', fontSize: '20px' }}>
                Atendimento à Imprensa, Mídia e Responsabilidade Social
              </DefaultText>
              <DefaultText size={isMobile ? "xs" : "small"} sx={{ fontFamily: 'Montserrat-Regular', lineHeight: '20px', fontSize: '16px' }}>
                comunicacao@telemont.com.br
              </DefaultText>
            </div>
            <div className={styles['contact-holder']}>
              <DefaultText size={isMobile ? "xs" : "small"} sx={{ fontFamily: 'Montserrat-Bold', lineHeight: '20px', fontSize: '20px' }}>
                Contato Comercial
              </DefaultText>
              <DefaultText size={isMobile ? "xs" : "small"} sx={{ fontFamily: 'Montserrat-Regular', lineHeight: '20px', fontSize: '16px' }}>
              comercial@telemont.com.br
              </DefaultText>
            </div>
            <div className={styles['contact-holder']}>
              <DefaultText size={isMobile ? "xs" : "small"} sx={{ fontFamily: 'Montserrat-Bold', lineHeight: '20px', fontSize: '20px' }}>
                Reclamações, denúncias, sugestões, críticas e elogios
              </DefaultText>
              <DefaultText size={isMobile ? "xs" : "small"} sx={{ fontFamily: 'Montserrat-Regular', lineHeight: '20px', fontSize: '16px' }}>
                Ouvidoria Telemont <br />
                0800 033 7566 <br />
                ouvidoria@telemont.com.br <br />
              </DefaultText>
            </div>
          </div>
          <img src={imgContatos} alt="Imagem ilustrativa contatos telemont" className={styles["banner-image"]} />
        </div>
      </div>
    </>
  );
};

export default Contatos;